export default __webpack_public_path__ + "static/media/09.c23f7510.png";